import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';

const STATUS_CONFIG = {
  verified: {
    label: 'Verificado Feb 2026',
    icon: <CheckCircleIcon sx={{ fontSize: '0.85rem' }} />,
    bgcolor: 'rgba(30,58,95,0.08)',
    color: 'primary.main',
  },
  recent: {
    label: 'Reciente',
    icon: <ScheduleIcon sx={{ fontSize: '0.85rem' }} />,
    bgcolor: 'action.hover',
    color: 'text.secondary',
  },
  needs_review: {
    label: 'Datos recientes',
    icon: <ScheduleIcon sx={{ fontSize: '0.85rem' }} />,
    bgcolor: 'action.hover',
    color: 'text.secondary',
  },
};

const FreshnessBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.needs_review;

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      size="small"
      sx={{
        bgcolor: config.bgcolor,
        color: config.color,
        fontWeight: 500,
        fontSize: '0.7rem',
        height: 22,
        '& .MuiChip-icon': { color: config.color },
      }}
    />
  );
};

export default FreshnessBadge;
